export const getCharLength = (char) => {
    const code = char.charCodeAt(0)
    if (code <= 0x7e || (code >= 0xff61 && code <= 0xff9f)) return 1
    return 2
}

export const getDisplayNameByLength = (name, maxLength) => {
    const normalizedName = name.normalize()
    let length = 0
    let i = 0
    for (; i < normalizedName.length; i++) {
        const charLength = getCharLength(normalizedName[i])
        if (length + charLength > maxLength) break
        length += charLength
    }
    if (i >= normalizedName.length) {
        return { displayName: normalizedName, truncated: false }
    }
    return { displayName: normalizedName.slice(0, i) + '…', truncated: true }
}
